<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Biometria | Provedores | Criação" />
    <v-row justify="center" align="center">
      <v-col>
        <form-biometric-provider
          v-if="model"
          v-model="model"
          :readonly="false"
          @submit="submit"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import BiometricProviderService, { BiometricProviderCreateRequest } from '@/services/BiometricProviderService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRouter } from 'vue-router'
import FormBiometricProvider from './form-biometric-provider.vue'
import TPageTitle from '@/components/TPageTitle.vue'

const loader = useLoader()
const router = useRouter()
const snackbar = useSnackBar()

const model = ref<BiometricProviderCreateRequest>({
  name: '',
  classpath: '',
  credentials: {},
})

async function submit(model: BiometricProviderCreateRequest) {
  try {
    loader.increment()

    await (new BiometricProviderService()).store(model)

    snackbar.show(
      'Provedor biométrico criado com sucesso',
      'success',
    )

    router.push({ name: 'list-biometric-providers' })
  } finally {
    loader.decrement()
  }
}
</script>
